import { usePage } from '@inertiajs/react'
import { CircleAlert, TriangleAlert } from 'lucide-react'
import { useState, useEffect } from 'react'

const FlashMessages = () => {
  const { flash } = usePage().props as { flash?: { alert?: string; notice?: string } }
  const [isVisible, setIsVisible] = useState(true)
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    if (flash?.alert || flash?.notice) {
      setShouldRender(true)
      setIsVisible(true)
      
      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(false)
        
        // Wait for animation to complete before unmounting
        setTimeout(() => {
          setShouldRender(false)
        }, 300)
      }, 5000)

      return () => clearTimeout(timer)
    } else {
      setShouldRender(false)
    }
  }, [flash])

  if (!shouldRender) {
    return null
  }

  if (flash?.alert) {
    return (
      <div className={`
        bg-red-100 text-red-800 p-4 rounded-md
        transition-all duration-300 ease-in-out
        ${isVisible ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform -translate-y-2'}
      `}>
        <div className="max-w-xl mx-auto flex justify-center items-center gap-2">
          <TriangleAlert className="w-6 h-6" />
          <p>{flash.alert}</p>
        </div>
      </div>
    )
  }

  if (flash?.notice) {
    return (
      <div className={`
        bg-blue-100 text-blue-800 p-4 rounded-md
        transition-all duration-300 ease-in-out
        ${isVisible ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform -translate-y-2'}
      `}>
        <div className="max-w-xl mx-auto flex justify-center items-center gap-2">
          <CircleAlert className="w-6 h-6" />
          <p>{flash.notice}</p>
        </div>
      </div>
    )
  }

  return null
}

export default FlashMessages